import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from "@mantine/core";
import { ArticleOutlined, DescriptionOutlined, FolderZipOutlined, ImageOutlined, PictureAsPdfOutlined, VideoLibraryOutlined } from "@mui/icons-material";
import { FileTypeEnum } from "../../graphql/graphql";
import { getFileIconColor } from "../../utils/File.utils";
export const FileIcon = ({ fileType, fileName, style }) => {
    const iconColor = getFileIconColor(fileType);
    const IconComponent = fileType === FileTypeEnum.PdfUpload
        ? PictureAsPdfOutlined
        : fileType === FileTypeEnum.ImageUpload
            ? ImageOutlined
            : fileType === FileTypeEnum.CsvUpload
                ? ArticleOutlined
                : fileType === FileTypeEnum.DocumentUpload
                    ? DescriptionOutlined
                    : fileType === FileTypeEnum.VideoUpload
                        ? VideoLibraryOutlined
                        : fileType === FileTypeEnum.ZipUpload
                            ? FolderZipOutlined
                            : DescriptionOutlined;
    const extension = fileName?.split(".").pop()?.toUpperCase();
    // Extract dimensions from style if they exist, otherwise default to 2rem
    const size = style?.fontSize || "2rem";
    return (_jsxs(Box, { style: {
            position: "relative",
            display: "inline-flex",
            width: size,
            height: size,
            ...style,
            fontSize: undefined // Remove fontSize from Box to avoid double-scaling
        }, children: [_jsx(IconComponent, { style: {
                    color: "var(--mantine-color-white)",
                    backgroundColor: iconColor,
                    padding: "0.3rem",
                    borderRadius: "0.5rem",
                    width: "100%",
                    height: "100%"
                } }), extension && (_jsx(Text, { variant: "body", fw: 900, style: {
                    position: "absolute",
                    bottom: -2,
                    right: -2,
                    backgroundColor: "var(--mantine-color-white)",
                    color: iconColor,
                    padding: "0 2px",
                    borderRadius: "2px",
                    lineHeight: 1,
                    fontSize: "8px",
                    border: `1px solid ${iconColor}`,
                    zIndex: 1
                }, children: extension }))] }));
};
